import { NavigationItem } from "../types/navigation";
export const DefaultNavigation: NavigationItem[] = [
  // {
  //     id: 'starter.dashboard',
  //     code: 'AdmissionDashboard',
  //     name: 'Dashboard',
  //     subtitle: '',
  //     icon: 'fas fa-th-large',
  //     href: '/dashboard/dashboard1',
  //     children: []
  // },
  {
    id: "starter.admission",
    code: "admin-view",
    name: "Admin",
    subtitle: "",
    icon: "fas fa-user-tie",
    href: "/usertypes/Admin-List",
    children: [],
  },
  // {
  //     id: 'starter.admission',
  //     code: 'ManageMembers',
  //     name: 'Member View',
  //     subtitle: '',
  //     icon: 'fas fa-user-tie',
  //     href: '/usertypes/member-view',
  //     children: []
  // },
  // {
  //     id: 'starter.admission',
  //     code: 'ManageMembers',
  //     name: 'Bidder View',
  //     subtitle: '',
  //     icon: 'fas fa-user-tie',
  //     href: '/usertypes/bidder-view',
  //     children: []
  // },
  {
    id: "starter.admission",
    code: "member-view",
    name: "Member",
    subtitle: "",
    icon: "fas fa-user-tie",
    href: "/usertypes/Member-List",
    children: [],
  },
  {
    id: "starter.admission",
    code: "bidder-view",
    name: "Bidder",
    subtitle: "",
    icon: "fas fa-user-tie",
    href: "/usertypes/Bidder-List",
    children: [],
  },
  // {
  //     id: 'starter.admission',
  //     code: 'ManageRunners',
  //     name: 'Bidders',
  //     subtitle: '',
  //     icon: 'fas fa-user-alt',
  //     href: '/drivers/driver-list',
  //     children: []
  // },
  // {
  //     id: 'starter.admission',
  //     code: 'ManageMissions',
  //     name: 'Jobs',
  //     subtitle: '',
  //     icon: 'fab fa-monero',
  //     href: '/missions/mission-list',
  //     children: []
  // },
  // {
  //     id: 'starter.admission',
  //     code: 'ManageVehicles',
  //     name: 'Vehicles',
  //     subtitle: '',
  //     icon: 'fas fa-bus	',
  //     href: '/vehicle',
  //     children: []
  // },
  {
    id: "starter.admission",
    code: "subscription-view",
    name: "Subscriptions",
    icon: "fab fa-speakap",
    href: "/subscriptions/subscriptions-list",
  },
  // {
  //     id: 'starter.admission',
  //     code: 'ManageTwilioSessions',
  //     name: 'Twilio Sessions',
  //     subtitle: '',
  //     icon: 'fa fa-check-circle',
  //     href: '/subscriptions/twillio-session',
  //     children: []
  // },
  {
    id: "starter.admission",
    code: "jobs-view",
    name: "Jobs",
    subtitle: "",
    icon: "fa fa-suitcase",
    href: "/jobs/job-list",
    children: [],
  },
  {
    id: "starter.admission",
    code: "reviews-view",
    name: "Ratings",
    icon: "fa fa-star",
    href: "#",
    children: [
      {
        id: "starter.admission",
        code: "reviews-view",
        name: "Member Rating",
        icon: "fa fa-heart",
        href: "/jobs/member-review",
        children: [],
      },
      {
        id: "starter.admission",
        code: "reviews-view",
        name: "Bidder Rating",
        icon: "fa fa-thumbs-up",
        href: "/jobs/bidder-review",
        children: [],
      },
    ],
  },
  {
    id: "starter.masters",
    name: "Masters",
    icon: "fa fa-table",
    code: "master-view",
    href: "#",
    children: [
      {
        id: "starter.admission",
        code: "master-view",
        name: "Subscription Package",
        icon: "fas fa-folder-plus",
        href: "/subscriptions/subscription-package-list",
        children: [],
      },
      {
        id: "starter.admission",
        code: "master-view",
        name: "Job-Category Type",
        icon: "fa fa-table",
        href: "/master/Job-Category-List",
        children: [],
      },
      {
        id: "starter.admission",
        code: "master-view",
        name: "Landing Pages",
        icon: "fa fa-table",
        href: "/master/landingpages-list",
        children: [],
      },
      {
        id: "starter.admission",
        code: "master-view",
        name: "Banner Pages",
        icon: "fa fa-table",
        href: "/master/banner-list",
        children: [],
      },
      // {
      //     id: 'starter.admission',
      //     code: 'master-view',
      //     name: 'Location Types',
      //     icon: 'fa fa-stream',
      //     href: '/master/Location-Type-List',
      //     children: []
      // },
      {
        id: "starter.admission",
        code: "master-view",
        name: "Terms & Condition",
        icon: "fa fa-marker",
        href: "/master/terms-condition",
        children: [],
      },
    ],
  },
  {
    id: "starter.admission",
    code: "roles-view",
    name: "Roles & Permissions",
    subtitle: "",
    icon: "fa fa-user-lock",
    href: "/usertypes/role-list",
  },

  // {
  //     id: 'starter.admission',
  //     code: 'ManageSubscription',
  //     name: 'Location Type Add',
  //     subtitle: '',
  //     icon: 'fab fa-speakap',
  //     href: '/masterr/Location-Type-Add',
  //     children: []
  // },
];
export const DefaultConfiguration: NavigationItem[] = [
  {
    id: "starter.admission",
    code: "ManageUsers",
    name: "Users",
    subtitle: "",
    icon: "fas fa-user-alt",
    href: "/users/users-list",
    children: [],
  },
  {
    id: "starter.admission",
    code: "ManageUserRole",
    name: "User Role",
    subtitle: "",
    icon: "fas fa-user-shield",
    href: "/users/user-role-list",
    children: [],
  },
  {
    id: "starter.admission",
    code: "ManageRECSPlans",
    name: "People2Work Plans",
    subtitle: "",
    icon: "fas fa-paper-plane",
    href: "/subscriptions/plan-list",
    children: [],
  },
  {
    id: "starter.admission",
    code: "ManageMissionsType",
    name: "Jobs Type",
    subtitle: "",
    icon: "fas fa-sun",
    href: "/missions/mission-type-list",
    children: [],
  },
  {
    id: "starter.admission",
    code: "ManageTermsConditions",
    name: "Terms & Conditions",
    subtitle: "",
    icon: "fab fa-weixin",
    href: "/subscriptions/terms-condition",
    children: [],
  },
  {
    id: "starter.admission",
    code: "ManageStatesAllowed",
    name: "States Allowed",
    subtitle: "",
    icon: "fas fa-building",
    href: "/settings/states-allowed-list",
    children: [],
  },
  {
    id: "starter.admission",
    code: "ManageSalesTax",
    name: "Sales Tax",
    subtitle: "",
    icon: "fas fa-percent",
    href: "/settings/sales-tax",
    children: [],
  },
  {
    id: "starter.admission",
    code: "ManageSettings",
    name: "Settings",
    subtitle: "",
    icon: "fas fa-cog",
    href: "/settings/settings",
    children: [],
  },
];
